/**
 * Page Metadata - SEO titles and descriptions for main pages
 * Use with react-helmet-async or update document.title and meta tags directly
 */

export const pageMetadata = {
  home: {
    title: "Hey Sri Lanka - Your AI Travel Partner",
    description: "Plan your perfect Sri Lanka trip with our AI travel partner. Chat with AI, explore attractions, save favorites, and create detailed itineraries."
  },
  chat: {
    title: "Chat with AI - Hey Sri Lanka",
    description: "Chat with your personal AI travel partner. Discover Sri Lankan attractions, food, hotels, and experiences with instant recommendations."
  },
  explore: {
    title: "Explore Sri Lanka - Attractions & Places",
    description: "Explore top-rated attractions, restaurants, hotels, and experiences across Sri Lanka. Browse curated places by category and location."
  },
  saved: {
    title: "Saved Places - Hey Sri Lanka",
    description: "View and manage your saved favorite places, attractions, restaurants, and hotels. Keep your favorite Sri Lankan discoveries in one place."
  },
  plan: {
    title: "Plan Your Trip - Hey Sri Lanka",
    description: "Plan your perfect Sri Lanka trip with our advanced trip planner. Create day trips, multi-day itineraries, and optimize your travel route."
  },
  featured: {
    title: "Featured Experiences - Hey Sri Lanka",
    description: "Discover curated featured experiences and hidden gems across Sri Lanka. Explore trending attractions and local recommendations."
  },
  profile: {
    title: "My Profile - Hey Sri Lanka",
    description: "Manage your Hey Sri Lanka account. Update profile, view saved places, verify phone number, and access account settings."
  }
};

/**
 * Update page metadata (title and description)
 * Call this in useEffect or at page load
 */
export function updatePageMetadata(title: string, description: string) {
  // Update document title
  document.title = title;
  
  // Update or create meta description tag
  let metaDescription = document.querySelector('meta[name="description"]');
  if (!metaDescription) {
    metaDescription = document.createElement('meta');
    metaDescription.setAttribute('name', 'description');
    document.head.appendChild(metaDescription);
  }
  metaDescription.setAttribute('content', description);
  
  // Update Open Graph tags for social sharing
  updateOpenGraphTags(title, description);
}

/**
 * Update Open Graph meta tags for better social sharing
 */
function updateOpenGraphTags(title: string, description: string) {
  updateOrCreateMetaTag('og:title', title);
  updateOrCreateMetaTag('og:description', description);
  updateOrCreateMetaTag('og:site_name', 'Hey Sri Lanka');
  updateOrCreateMetaTag('og:type', 'website');
  updateOrCreateMetaTag('twitter:title', title);
  updateOrCreateMetaTag('twitter:description', description);
  updateOrCreateMetaTag('twitter:card', 'summary_large_image');
}

/**
 * Helper to update or create meta tags
 */
function updateOrCreateMetaTag(property: string, content: string) {
  let tag = document.querySelector(`meta[property="${property}"], meta[name="${property}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    const isProperty = !property.startsWith('twitter:') && !property.startsWith('og:');
    if (property.startsWith('og:')) {
      tag.setAttribute('property', property);
    } else {
      tag.setAttribute('name', property);
    }
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}

